import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { queryClient } from '@/config/queryClient';
import { AuthProvider } from '@/contexts/AuthProvider';
import { SidebarProvider } from '@/contexts/SidebarProvider';
import { AppRoutes } from '@/routes/AppRoutes';
import { ErrorBoundary } from '@/components/error/ErrorBoundary';

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <SidebarProvider>
              <ErrorBoundary>
                <AppRoutes />
              </ErrorBoundary>
            </SidebarProvider>
            <Toaster position="top-right" />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
